module.exports = __webpack_public_path__ + "img/blanco_avion.81c03846.png";